import { useQuery } from "@tanstack/react-query";
import { qk } from "./queryKeys";
import { search } from "@/api/search";

export function useSearch(q: string, types: string[] = [], caseId?: string) {
  return useQuery({
    queryKey: qk.search(q, types),
    queryFn: () => search({ q, types, caseId }),
    enabled: q.length >= 2,
    staleTime: 15_000,
  });
}
